module.exports = __webpack_public_path__ + "static/media/james.7f18d6eb.jpg";